import { Directive, ElementRef, Optional } from '@angular/core';
import { CapFormControlComponent } from './form-control.component';

/**
 * Registers the element this directive is applied as input with the parent form-control (if a parent form-control exists).
 */
@Directive({
  selector: '[capRegisterFormControlInput]'
})
export class RegisterFormControlInputDirective {
  constructor(@Optional() formControl: CapFormControlComponent, elementRef: ElementRef) {
    if (formControl) {
      formControl.registerChild(elementRef);
    }
  }
}
